<template>
    <div v-if="loaded">
        <card-header icon="fa-file-certificate" :title="application.title" />
        <card-body>
            <card-list>
                <subheader-list-item icon="fa-align-left" title="Dates" />
                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Reject Action" label-position="inside">
                                <b-select expanded v-model="rejection.action">
                                    <option :value="index+1" v-for="(step, index) in application.outline">Reset to Step {{ index + 1 }} - {{ step.title }}, with Message</option>
                                    <option value="stop">Terminate Application (No Retry), with Message</option>
                                    <option value="reset">Completely Reset/Delete Application (Retry)</option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Rejection Message" label-position="inside">
                                <b-input type="textarea" position="is-bottom-right" v-model="rejection.message" expanded></b-input>
                                <template #message>Message will be included in rejection email and displayed to applicant in their application (if possible).</template>

                            </b-field>
                            <b-dropdown @change="applyTemplate">
                                <template #trigger="{ active }">
                                    <b-button
                                        label="Template"
                                        type="is-primary"
                                        size="is-small"
                                        :icon-right="active ? 'fas fa-caret-up' : 'fas fa-caret-down'"
                                    />
                                </template>

                                <b-dropdown-item value="signature">Problem with Signature</b-dropdown-item>
                                <b-dropdown-item value="attendance">Unable to Validate Attendance</b-dropdown-item>
                                <b-dropdown-item value="log">Conflicting Log Times</b-dropdown-item>

                            </b-dropdown>
                        </div>
                    </div>
                </container-list-item>
            </card-list>

        </card-body>

        <card-footer>
            <div class="columns">
                <div class="column">
                    <div class="is-pulled-right">
                        <b-button
                            type="is-danger"
                            size="is-small"
                            class="m-2"
                            @click="reject"
                            :disabled="rejection.action === null || rejection.message === ''"
                        >
                            <b-icon icon="times" class="mr-2"></b-icon>
                            Reject
                        </b-button>
                    </div>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import RenderComponent from "@/components/RenderComponent";

    import {client as http} from "@/http_client";
    import CardFooter from "../../TIER/components/CardFooter";
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import DataRow from "../../TIER/components/DataRow";
    import moment from "moment";
    import SeparatorListItem from "../../TIER/components/SeparatorListItem";
    import CardListItem from "../../TIER/components/CardListItem";
    import async from "async";
    import ApplicationView from "../applications/applicants/ApplicationView.vue";

    export default {
        components: {ApplicationView, CardListItem, SeparatorListItem, DataRow, ContainerListItem, SubheaderListItem, CardList, CardFooter, RenderComponent, CardBody, CardHeader},
        props: ['card', 'props'],
        data: function () {
            return {
                applicant: null,
                application: null,
                rejection: {
                    action: null,
                    message: '',
                },
                loaded: false
            };
        },
        computed: {
            confDates: function () {
                let s = moment(this.conf.conference.start_at);
                let e = moment(this.conf.conference.end_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
        },
        methods: {
            loadReview: function () {
                this.$emit('loading', true);
                async.series([
                    // get applicant
                    (cb) => {
                        http.get('/applicants/conf/' + this.props.reviewId, {force: true}).then(response => {
                            this.applicant = response.data;
                            cb()
                        }).catch(err => {
                            cb(err);
                        });
                    },
                    // get application
                    (cb) => {
                        http.get('applications/' + this.applicant.conf_applications.application_id, {force: true}).then(response => {
                            if (!response.data.outline) response.data.outline = [];
                            this.application = response.data;
                            cb()
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                    this.loaded = true;
                });
            },
            applyTemplate: function (template) {
                switch (template) {
                    case 'signature':
                        this.rejection.message = 'We were unable to validate your signature. Either it was incomplete or unreadable. Please resubmit your application with a valid signature.';
                        break;
                    case 'attendance':
                        this.rejection.message = 'We were unable to validate your attendance. If you feel this is a mistake, please contact support@my247ed.com.';
                        break;
                    case 'log':
                        this.rejection.message = 'We are unable to validate your record log.  Please make sure there are no errors or conflicts and resubmit.';
                        break;
                }
            },

            reject() {
                this.$emit('loading', true);
                http.post('/applications/reject/', {id: this.props.reviewId, ...this.rejection}).then(response => {
                    this.$openCard('reviews');
                    this.$reloadCard('reviews');
                }, err => {
                    console.log(err);
                });
            },
            // getData(conf, field) {
            //     for (let i = 0; i < this.conf.config.data.length; i++) {
            //         const datum = this.conf.config.data[i];
            //         if (datum.field === field) {
            //             return JSON.parse(datum.value);
            //         }
            //     }
            // },
            displayDates: function (start, end) {
                let s = moment(start);
                let e = moment(end);
                if (s.isSame(e, 'day')) {
                    return s.format('dddd, MMMM Do, h:mm A') + ' - ' + e.format('h:mm A');
                } else {
                    return s.format('MMM Do, h:mm A') + ' - ' + e.format('MMM Do, h:mm A');
                }
            },
        },
        watch: {
            'props.reviewId': function () {
                this.loadReview();
            }
        },
        mounted: function () {
            this.loadReview();
        }
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .component-content {
        margin: 2rem 0;
    }
</style>
